import { api } from './client';

export interface BackendFarmerLimitSummary {
  _id: string;
  htxId: string;
  farmerId: string;
  tier: 'A' | 'B' | 'C' | 'D';
  totalLimitVnd: string;
  usedAmountVnd: string;
  lockedAmountVnd: string;
  lockExpiresAt?: string;
  pendingLoanId?: string;
}

export interface BackendFarmerDashboard {
  limit: BackendFarmerLimitSummary | null;
  loans: {
    pendingCount: number;
    activeCount: number;
    overdueCount: number;
    totalOutstandingVnd: string;
  };
  notifications: { unreadCount: number };
  farmLogs: { recentCount: number; lastLogAt: string | null };
  harvests: { pendingCount: number };
  materials: { activeCount: number };
}

export interface BackendHtxDashboard {
  farmers: { total: number; pendingEkycCount: number };
  loans: {
    pendingApprovalCount: number;
    activeCount: number;
    overdueCount: number;
    totalOutstandingVnd: string;
  };
  contracts: { total: number; activeCount: number; expiringSoonCount: number };
  harvests: { pendingConfirmCount: number };
  supply: { lowStockCount: number; totalItems: number };
  approvalWorklist: { pendingTotal: number };
  finance: {
    totalLimitVnd: number;
    allocatedVnd: number;
    remainingToAllocateVnd: number;
    loanCount: number;
    farmersWithLoanCount: number;
  };
}

export async function getFarmerDashboard(farmerId: string): Promise<BackendFarmerDashboard> {
  return api.get<BackendFarmerDashboard>(`/portal/farmer/${farmerId}/dashboard`);
}

export async function getHtxDashboard(htxId: string): Promise<BackendHtxDashboard> {
  return api.get<BackendHtxDashboard>(`/portal/htx/${htxId}/dashboard`);
}
